import store from '~/javascripts/store.js';

const UserAccessSection = ({
  avatarUrl,
  currentUserPresent,
  signInParams,
  teams,
  userEmail,
  userFullName,
  userHasOpenCampaigns,
  userSlug,
}) => {
  const handleClick = () => {
    if (!window.isDesktop) {
      store.nav.toggleOffCanvasAccountSection();
    }
  };

  return (
    <div className='mycw-nav theme-design-system-v1'>
      {currentUserPresent ? (
        <div
          className='has-dropdown not-click relative cursor-pointer lg-cursor-auto'
          onClick={handleClick}
        >
          <img
            alt='Avatar'
            className='mr-5 rounded-full'
            height='27'
            src={avatarUrl}
            width='27'
          />
          <span className='icn cw-icon-caret-down' />

          <ul className='dropdown dropdown-right prodash rounded'>
            <li className='contains-caret profile-caret'>
              <span className='icn cw-icon-caret-up' />
            </li>
            <li className='dropdown-child'>
              <a
                className='no-underline px-3 py-5 bg-cw-brand-yellow-100'
                href={`/${userSlug}`}
              >
                <div className='flex'>
                  <img
                    alt='Avatar'
                    className='mr-4 rounded-full'
                    height='42'
                    src={avatarUrl}
                    width='42'
                  />
                  <div className='text-left'>
                    <div className='text-md truncate-line'>{userFullName}</div>
                    <div className='body-s font-normal text-grey-50 truncate-line'>
                      {userEmail}
                    </div>
                  </div>
                </div>
              </a>
            </li>

            <li className='dropdown-child'>
              <a
                className='text-md no-underline px-3 py-5'
                href={`/${userSlug}`}
              >
                My profile
              </a>
            </li>

            <li className='dropdown-child'>
              <a
                className='text-md no-underline px-3 py-5'
                href='/account/giving-history'
              >
                My dashboard
              </a>
            </li>

            <li className='dropdown-child'>
              {userHasOpenCampaigns ? (
                <a
                  className='text-md no-underline px-3 py-5'
                  href='/account/fundraisers'
                >
                  My fundraisers
                </a>
              ) : (
                <a
                  className='text-md no-underline px-3 py-5'
                  href='#start-fundraiser'
                >
                  Start a fundraiser
                </a>
              )}
            </li>

            <li className='dropdown-child'>
              <a
                className='text-md no-underline px-3 py-5'
                href='/account/settings'
              >
                Account settings
              </a>
            </li>

            {teams.length > 0 && (
              <li className='dropdown-child'>
                <div className='team-header text-grey-60 mb-1 uppercase font-bold px-3 pt-5'>
                  Your Teams
                </div>
                {teams.map(({ name, slug }) => (
                  <a
                    className='team-name text-md no-underline px-3 py-5'
                    href={`/teams/${slug}`}
                    key={slug}
                  >
                    {name}
                  </a>
                ))}
              </li>
            )}

            <li className='dropdown-child'>
              <a
                className='text-md no-underline px-3 py-5'
                href='#'
                {...{ 'hx-delete': '/account/logout' }}
              >
                Sign Out
              </a>
            </li>
          </ul>
        </div>
      ) : (
        <div className='has-form user-access'>
          <a className='log-in' href={`/account/login${signInParams}`}>
            Sign in
          </a>
        </div>
      )}
    </div>
  );
};

export default UserAccessSection;
